import { FC, useCallback, useEffect, useState } from 'react'

import { Tab } from 'components'
import { useLocation } from 'react-router-dom'

import { AddAnalysisCre } from './components/AddAnalysisCre/AddAnalysisCre'
import AnalyzeCre from './components/AnalyzeCre/AnalyzeCre'
import { string } from 'yup'
import useApp from 'hooks/useApp'

const Cre: FC = () => {
  const location = useLocation<any>()
  const [tabs, setTabs] = useState(['Pesquisar', 'Adicionar Novo'])

  const [selectedTab, setSelectedTab] = useState(
    location?.state?.cdContrato &&
      location?.state?.dtCompetencia &&
      location?.state?.pathBack
      ? 1
      : 0
  )
  // const [idCre, setidCre] = useState(0)
  const [tabBack, setTabBack] = useState(0)
  const [tab, setTab] = useState(0)
  const [pathBack, setpathBack] = useState<string>('')
  const [cdContrato, setCdContrato] = useState<string>('')
  const [nmFornecedor, setNmFornecedor] = useState<string>('')
  const [dtCompetencia, setDtCompetencia] = useState<string>('')
  const [idCreAnalise, setidCreAnalise] = useState()

  const { setTitlePage } = useApp()


  const handleChange = (_, newValue) => {
    if (newValue === 0) {
      location.state = {}
      setTabs(['Pesquisar', 'Adicionar Novo'])
    }
    setSelectedTab(newValue)
  }
  const handleChangeName = (_newName: string) => {
    setTabs(['Pesquisar', _newName])
  }

  const handleCre = useCallback(() => {
    if (
      location?.state?.cdContrato &&
      location?.state?.dtCompetencia &&
      location?.state?.pathBack
    ) {
      setSelectedTab(1)
    }
  }, [location])
  useEffect(() => {
    handleCre()
  }, [handleCre])

  useEffect(() => {
    if (location?.state?.idFornecedor > 0) {
      setSelectedTab(1)
    }
  }, [])
  useEffect(() => {
    const dadosCre = JSON.parse(localStorage.getItem('dados'))
    // setidCre(dadosCre.idCre)
    if (dadosCre) {
      setTab(dadosCre.tab)
      setSelectedTab(dadosCre.tab)
      setpathBack(dadosCre.pathBack)
      setCdContrato(dadosCre.cdContrato)
      setNmFornecedor(dadosCre.nmFornecedor)
      setDtCompetencia(dadosCre.dtCompetencia)
      setidCreAnalise(dadosCre.idCreExist)
      setTabBack(dadosCre.tabBack)
    }
    localStorage.removeItem('dados')
  }, [])

  return (
    <>
      <Tab tabs={tabs} value={selectedTab} handleChange={handleChange} />
      {selectedTab === 0 && <AnalyzeCre />}
      {selectedTab === 1 && (
        <AddAnalysisCre
          isConsult={location?.state?.isConsult}
          idCreExist={
            location?.state?.idCreExist == undefined
              ? idCreAnalise
              : location?.state?.idCreExist
          }
          tabBack={
            location?.state?.tabBack == undefined
              ? tabBack
              : location?.state?.tabBack
          }
          pathBack={
            location?.state?.pathBack == undefined
              ? pathBack
              : location?.state?.pathBack
          }
          nmFornecedor={
            location?.state?.nmFornecedor == undefined
              ? nmFornecedor
              : location?.state?.nmFornecedor
          }
          handleChangeName={handleChangeName}
          cdContratoCre={
            location?.state?.cdContrato == undefined
              ? cdContrato
              : location?.state?.cdContrato
          }
          NuAnoMesCompetenciaCre={
            location?.state?.dtCompetencia == undefined
              ? dtCompetencia
              : location?.state?.dtCompetencia
          }
        />
      )}
    </>
  )
}

export default Cre
